import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../Components/Layout/Layout";
import Filters from "../Home/Components/Filters";
import { getCertificateKidList, getCertificates } from "../../redux/actions/student";
import "./style.css";
import "./responsive.css";
import { CERTIFICATE_FILTER } from "../../redux/actions/types";
import { setFilters } from "../../redux/actions/dashboard";
import { certificateActiveFilter, meritLevelList } from "../../helper/general";

const StudentAchievements = () => {

  const dispatch = useDispatch();

  const certificateFilter = useSelector(state => state.student.certificateFilter);
  const certificateList = useSelector(state => state.student.certificateList);
  const certificateKidList = useSelector(state => state.student.certificateKidList);

  const [activePage, setActivePage] = useState(1);

  var studentNameList = certificateKidList?.data?.reduce((obj, item) => Object.assign(obj, { [item.id]: item.name }), {});
  const additionalFilter = { "Student Name": { ...studentNameList }, "Merit Level": meritLevelList }

  useEffect(() => {
    dispatch(getCertificates({ ...certificateFilter, pageNo: 0, pageSize: 10 }));
  }, [])

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setActivePage(pageNumber);
    dispatch(getCertificates({ ...certificateFilter, pageNo: page, pageSize: 10 }));
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    const data = { ...certificateFilter }
    let index = data[name]?.indexOf(parseInt(value));
    if (name == "meritList") {
      index = data[name]?.indexOf(value);
    }

    if (index >= 0) {
      data[name].splice(index, 1)
    } else {
      if (name == "meritList") {
        data[name].push(value);
      } else {
        data[name].push(parseInt(value));
      }
    }
    dispatch(setFilters(CERTIFICATE_FILTER, data));
    setActivePage(1);
    dispatch(getCertificates({ ...data, pageNo: 0, pageSize: 10 }));
  }

  const handleStudentSearch = e => {
    const { name, value } = e.target;
    if (certificateFilter?.kidIds?.length) {
      dispatch(setFilters(CERTIFICATE_FILTER, { ...certificateFilter, kidIds: [] }));
      const currentFilter = { ...certificateFilter, kidIds: [] }
      dispatch(getCertificates({ ...currentFilter, pageNo: 0, pageSize: 10 }));
    }
    if (value.length > 2) {
      dispatch(getCertificateKidList({ ...certificateFilter, nameLike: value, pageNo: 0, pageSize: 100 }));
    }
  }

  return (
    <Layout title="Student Achievements" page="achievements">
      <div className="m-top-3"><div className="page-title"><h2>Student Achievements</h2></div></div>
      <div className="container-fluid">
        <Filters handleFilterChange={handleFilterChange} filterData={certificateFilter} activeFilter={certificateActiveFilter} additionalFilter={additionalFilter} additionMethod={handleStudentSearch} />
      </div>
      <div className="certificate-cards row px-2 mx-0">
        {certificateList?.data?.map((item, key) => {
          return (
            <div className="col-12 col-sm-10 col-md-9 col-lg-7 col-xl-6  px-2 mx-auto">
              <div className="card rounded-0 border-0">
                <img src={item?.certificateUrl} alt="loading..." />
              </div>
              <h5 className="ach-name mb-5 fw-bold text-center mt-3">{item?.achievementName}</h5>
            </div>
          )
        })}
        {certificateList?.pagination_info &&
          <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
            <p className="counting mb-0">{activePage} out of {certificateList?.pagination_info?.total_pages}</p>
            <nav aria-label="Page navigation example">
              <Pagination
                activePage={activePage}
                itemsCountPerPage={certificateList?.pagination_info?.page_size}
                totalItemsCount={certificateList?.pagination_info?.total_elements}
                pageRangeDisplayed={5}
                innerClass="pagination mb-0 p-0"
                itemClass="page-item"
                linkClass="page-link"
                onChange={handlePageChange}
              />
            </nav>
          </div>
        }
      </div>
    </Layout>
  );
};

export default StudentAchievements;
